module.exports = __webpack_public_path__ + "img/홍대 네일.f2dd509d.png";